import Types from './Member.type';

export const setThisSessionMember = ({ member }: { member: any }) => {
  return {
    type: Types.SET_THIS_SESSION_MEMBER,
    payload: { member },
  };
};
